// Technician Portal Route Configuration
import { lazy } from 'react';

const TechnicianDashboard = lazy(
  () => import('../../portals/technician/pages/dashboard/TechnicianDashboard')
);
const TechnicianJobsList = lazy(
  () => import('../../portals/technician/pages/jobs/TechnicianJobsList')
);
const TechnicianStockPage = lazy(
  () => import('../../portals/technician/pages/stock/TechnicianStockPage')
);
const TechnicianProfile = lazy(
  () => import('../../portals/technician/pages/profile/TechnicianProfile')
);

/**
 * Technician Portal Routes
 *
 * Phase 4A: scaffold (dashboard + 3 stub pages routed from bottom nav).
 * Phase 4B: real Jobs list + detail.
 * Phase 4C: 5-step Job Wizard (mounted under /technician/jobs/:id/wizard).
 * Phase 4D: real My Stock page + transfer-request flow.
 *
 * Portal access is gated by EnhancedUser.assigned_portal == 'technician'
 * via TechnicianPortalRoute (see routing/guards/PortalRoute.js).
 */
export const technicianRoutes = {
  path: '/technician',
  name: 'Technician Portal',
  description: 'Field technician job-card workspace',
  requiredRoles: [], // Portal access determined by assigned_portal field
  requiredPermissions: [],
  children: [
    {
      index: true,
      component: TechnicianDashboard,
      name: 'Dashboard',
      description: 'Technician dashboard',
      requiredPermissions: [],
      meta: {
        title: 'Technician Dashboard',
        breadcrumb: 'Dashboard',
        icon: 'dashboard',
      },
    },
    {
      path: 'jobs',
      component: TechnicianJobsList,
      name: 'My Jobs',
      description: 'Job cards assigned to this technician',
      requiredPermissions: [],
      meta: {
        title: 'My Jobs',
        breadcrumb: 'Jobs',
        icon: 'assignment',
      },
    },
    {
      path: 'stock',
      component: TechnicianStockPage,
      name: 'My Stock',
      description: "Stock currently held by this technician",
      requiredPermissions: [],
      meta: {
        title: 'My Stock',
        breadcrumb: 'Stock',
        icon: 'inventory_2',
      },
    },
    {
      path: 'profile',
      component: TechnicianProfile,
      name: 'Profile',
      description: 'Technician account info',
      requiredPermissions: [],
      meta: {
        title: 'Profile',
        breadcrumb: 'Profile',
        icon: 'person',
      },
    },
  ],
};

export default technicianRoutes;
